










































































import { Component, Prop, Vue } from "@/shared/vuepack";
import CommonTabs from "@/employer/components/shared/CommonTabs.vue";
import CommonTab from "@/employer/components/shared/CommonTab.vue";
import Metric from "@/employer/components/metric/Metric.vue";
import { ProductPlanTab } from "@/employer/types";
import { Config } from "@/shared/config";
import Button from "@/shared/components/ui/Button.vue";
import OptimizeModal from "@/employer/components/metric/OptimizeModal.vue";

@Component({
  components: {
    Button,
    CommonTabs,
    CommonTab,
    Metric,
    OptimizeModal
  },
})
export default class MetricWithGraph extends Vue {
  @Prop() componentTitle!: string;
  @Prop() hasOptimize!: boolean;
  @Prop() employerCode!: string;
  @Prop() accessToken!: string;
  @Prop() metricBanners!: ProductPlanTab[];

  activeBanners: string[] = [];
  loadedBanners: string[] = [];
  showCloseAllButton = false;
  tableauUrl = Config.UserServicebaseUri;

  showOptimizeModal = false;
  modalMetricName = "";

  toggleBannerActive (name: string): void {
    this.addLoadedBanner(name);
    if (this.activeBanners.includes(name)) {
      this.activeBanners = this.activeBanners.filter(i => i !== name);
    }
    else {
      this.activeBanners.push(name);
    }
    this.showCloseAllButton = this.activeBanners.length > 1;
  }

  toggleModal (metricName: string): void {
    this.modalMetricName = metricName ?? this.modalMetricName;
    this.showOptimizeModal = !this.showOptimizeModal;
  }

  addLoadedBanner (name: string): void {
    if (!this.loadedBanners.includes(name)) {
      this.loadedBanners.push(name);
    }
  }

  closeAllBanners () {
    this.activeBanners = [];
    this.showCloseAllButton = false;
  }
}
